import { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { useCarePlanService } from '@/shared/guard';
import { useFctReport, useFindingsByOrgan } from '@/shared/hook';
import { isNotEmpty } from '@/shared/util';

import { useUpfrontReportValidation } from '../../hook';
import { useCreateActivityLog } from './use-create-activity-log.hook';
import { useEvaluateLinks } from './use-evaluate-links.hook';

export function ReportingState() {
  const { links } = useCarePlanService();
  const evaluateLinks = useEvaluateLinks(links);
  const { report } = useFctReport();
  const { defaultFindings, findings } = useFindingsByOrgan();

  useUpfrontReportValidation(links);

  useCreateActivityLog(report);

  const shouldEvaluateLinks = useMemo(
    () =>
      isNotEmpty(Object.keys(findings)) ||
      Boolean(links) ||
      isNotEmpty(Object.keys(defaultFindings)),
    [defaultFindings, findings, links],
  );

  useEffect(() => {
    if (shouldEvaluateLinks) {
      evaluateLinks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [findings, links, defaultFindings]);

  return <Outlet />;
}
